import { z } from 'zod';
import { IdSchema, IsoDateTimeSchema, nullableText, paginated } from './common.js';
import { PaymentMethodSchema, PaymentStatusSchema } from './enums.js';
import { MoneySchema, parseTiyin } from './money.js';
/**
 * To'lov.
 *
 * MVP da ilova ichida to'lov oqimi yo'q: shart telefonda kelishiladi, pulni
 * olganini admin panelda admin yoki sotuv menejeri yozadi.
 *
 * Har qator — HAQIQATDA olingan pul. Qisman to'lov alohida status EMAS,
 * u qatorlardan hisoblanadi (`OrderPaymentState`).
 */
export const PaymentResponseSchema = z.object({
    id: IdSchema,
    orderId: IdSchema,
    method: PaymentMethodSchema,
    status: PaymentStatusSchema,
    amount: MoneySchema,
    receiptUrl: nullableText(255),
    submittedAt: IsoDateTimeSchema.nullable(),
    bankRef: nullableText(120),
    verifiedById: IdSchema.nullable(),
    verifiedByName: z.string().nullable(),
    verifiedAt: IsoDateTimeSchema.nullable(),
    rejectReason: nullableText(255),
    cardLast4: nullableText(4),
    cardOwner: nullableText(80),
    createdAt: IsoDateTimeSchema,
});
/** Buyurtmaning to'lov holati — qatorlardan HISOBLANADI, saqlanmaydi. */
export const ORDER_PAYMENT_STATES = ['UNPAID', 'PARTIAL', 'PAID', 'OVERPAID'];
export const OrderPaymentStateSchema = z.enum(ORDER_PAYMENT_STATES);
/** Yagona joyda hisoblanadi — har modulda qaytadan yozilmaydi. */
export function computePaymentState(confirmedTotal, grandTotal) {
    if (confirmedTotal <= 0n)
        return 'UNPAID';
    if (confirmedTotal < grandTotal)
        return 'PARTIAL';
    if (confirmedTotal > grandTotal)
        return 'OVERPAID';
    return 'PAID';
}
/** Pul olinganini yozish. Summa serverda buyurtmaga qarab tekshiriladi. */
export const RecordPaymentSchema = z
    .object({
    method: PaymentMethodSchema.default('CASH'),
    amount: MoneySchema,
    receiptUrl: z.string().trim().max(255).optional(),
    cardLast4: z
        .string()
        .regex(/^\d{4}$/)
        .optional(),
    cardOwner: z.string().trim().max(80).optional(),
    note: z.string().trim().max(255).optional(),
})
    .strict()
    .refine((v) => (parseTiyin(v.amount) ?? 0n) > 0n, {
    message: "To'lov summasi musbat bo'lishi kerak",
    path: ['amount'],
});
/**
 * Tasdiqlash. `payment.confirm` ruxsati talab qilinadi — Operator qila olmaydi.
 *
 * `CARD_TRANSFER` da `bankRef` MAJBURIY: chek skrinshoti dalil emas.
 * Naqdda bank ma'lumotnomasi bo'lmaydi, dalil — kim qabul qilgani
 * (`verifiedById` serverda joriy foydalanuvchidan qo'yiladi).
 */
export const ConfirmPaymentSchema = z
    .object({
    bankRef: z.string().trim().max(120).optional(),
    note: z.string().trim().max(255).optional(),
})
    .strict();
/**
 * `bankRef` shu usulda MAJBURIYmi.
 *
 * Qoida bitta joyda: server ham, admin paneldagi forma ham shu funksiyadan
 * o'qiydi. Ikki joyda alohida yozilsa ular ajralib ketadi va forma
 * majburiy emas deb ko'rsatib turgani holda server 400 qaytaradi.
 *
 * Naqd — YAGONA istisno: qo'ldan qo'lga berilgan pulda bank ma'lumotnomasi
 * bo'lmaydi, dalil — kim qabul qilgani (`verifiedById`). Qolgan hamma usul
 * (karta, Payme, Click) tashqi tizimdan o'tadi va u yerda albatta iz
 * qoladi. Ro'yxatni `CARD_TRANSFER` bilan cheklab qo'yish Payme/Click ga
 * dalilsiz tasdiqlash yo'lini ochib qo'yardi.
 */
export function requiresBankRef(method) {
    return method !== 'CASH';
}
export const RejectPaymentSchema = z
    .object({ rejectReason: z.string().trim().min(1).max(255) })
    .strict();
/* ------------------------- tasdiqlash navbati ------------------------- */
/**
 * Tasdiqlanmagan to'lov qatori — moliya navbati.
 *
 * Operator pul olinganini yozadi, lekin tasdiqlay olmaydi (vazifalar
 * ajratilishi). Shu qator qayerdadir ko'rinmasa, u buyurtma ichida
 * ko'milib qoladi: tasdiqlovchi uni faqat tasodifan topadi. Navbat —
 * yozish va tasdiqlash orasidagi ko'prik.
 */
export const PaymentQueueItemSchema = z.object({
    payment: PaymentResponseSchema,
    orderNumber: z.string(),
    customerName: z.string(),
    customerPhone: z.string(),
    /** Buyurtmaning umumiy summasi — qator o'rinlimi, shundan ko'rinadi. */
    grandTotal: MoneySchema,
    /** Shu buyurtma bo'yicha ALLAQACHON tasdiqlangan summa. */
    paidTotal: MoneySchema,
    orderCreatedAt: IsoDateTimeSchema,
});
export const PaymentQueueResponseSchema = paginated(PaymentQueueItemSchema);
export const ListPaymentsQuerySchema = z
    .object({
    /** Standart — `PENDING`: navbatning butun ma'nosi shu. */
    status: PaymentStatusSchema.default('PENDING'),
    method: PaymentMethodSchema.optional(),
    limit: z.coerce.number().int().min(1).max(100).default(25),
    cursor: z.string().max(255).optional(),
})
    .strict();
//# sourceMappingURL=payment.js.map